"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ExtendableError_1 = __importDefault(require("./ExtendableError"));
class ConditionDidNotMatchError extends ExtendableError_1.default {
    constructor(message) {
        super(`The condition did not match: ${message}`, {
            isRetryable: true
        });
    }
}
exports.default = ConditionDidNotMatchError;
